export default "__VITE_ASSET__22b811ff__"